/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagMediaDirectoryRequest
 */
export interface TagMediaDirectoryRequest {
    /**
     * 
     * @type {number}
     * @memberof TagMediaDirectoryRequest
     */
    tag: number;
    /**
     * 
     * @type {boolean}
     * @memberof TagMediaDirectoryRequest
     */
    add: boolean;
}

export function TagMediaDirectoryRequestFromJSON(json: any): TagMediaDirectoryRequest {
    return TagMediaDirectoryRequestFromJSONTyped(json, false);
}

export function TagMediaDirectoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagMediaDirectoryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tag': json['tag'],
        'add': json['add'],
    };
}

export function TagMediaDirectoryRequestToJSON(value?: TagMediaDirectoryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tag': value.tag,
        'add': value.add,
    };
}


